import { alpha, Skeleton, Stack } from "@mui/material";
import { m } from "framer-motion";
import { useContext } from "react";
import palette from "src/theme/palette";

import ThemeContext from "../../../context";

// ----------------------------------------------------------------------

export const SkeletonForm = () => {
	const { themeType } = useContext(ThemeContext);
	const isDark = themeType === "dark";
	const backgroundColor = alpha(
		isDark ? palette.dark.action.disabled : palette.light.action.disabled,
		0.1
	);

	const sx = { borderRadius: 1, backgroundColor };

	return (
		<Stack
			gap={2}
			component={m.div}
			sx={{ mt: 0 }}
			initial={{ opacity: 1 }}
			animate={{ opacity: 0 }}
			transition={{ duration: 1 }}
			exit={{ opacity: 0 }}
		>
			<Skeleton variant='rectangular' width={"100%"} height={50} sx={sx} />
			<Skeleton variant='rectangular' width={"100%"} height={50} sx={sx} />
			<Skeleton variant='text' sx={{ mb: 1, backgroundColor }} width={"100%"} height={20} />
			<Skeleton variant='rectangular' width={"100%"} height={55} sx={{ ...sx, mt: 5 }} />
		</Stack>
	);
};

export default SkeletonForm;
